module.exports = __webpack_public_path__ + "assets/images/welcome-page-side-logo.png";